<template>
    <b-modal
        id="ModalUpdateMedia"
        title="Modifier un média"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        size="xl"
        hide-footer
    >
        <FormMedia
            :context="context"
            :media="media"
            @saved="onSaved"
            class="mb-2 h-50"
        />
    </b-modal>
</template>
<script>
import FormMedia from "./FormMedia";
export default {
    components: {
        FormMedia,
    },

    props: {
        context: { type: Object, required: true },
        media: { type: Object, required: true },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalUpdateMedia");
            this.$emit("saved");
        },
    },
};
</script>
